export default /^[1-9][0-9]{1,9}(-\d*)?$/;
